import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { classNames } from '@/lib/utils';

interface SubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  children: ReactNode;
}

export function SubmitButton({
  loading = false,
  disabled,
  children,
  className,
  type = 'submit',
  ...rest
}: SubmitButtonProps): JSX.Element {
  const isDisabled = disabled || loading;
  return (
    <button
      {...rest}
      type={type}
      disabled={isDisabled}
      className={classNames(
        'w-full inline-flex items-center justify-center gap-2',
        'rounded-md px-4 py-3 font-display tracking-[0.2em] uppercase text-sm',
        'bg-sea-deep text-candle border-2 border-candle/50',
        'shadow-[0_2px_8px_rgba(0,0,0,0.4)]',
        'hover:bg-sea-dark hover:border-candle hover:shadow-[0_2px_12px_rgba(232,177,75,0.2)]',
        'transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-candle focus:ring-offset-2 focus:ring-offset-parchment',
        'disabled:opacity-60 disabled:cursor-not-allowed',
        'min-h-12',
        className,
      )}
    >
      {loading && (
        <span
          aria-hidden
          className="inline-block h-3.5 w-3.5 rounded-full border-2 border-candle/40 border-t-candle animate-spin"
        />
      )}
      <span>{children}</span>
    </button>
  );
}
